import { IconArrowsArrowRight } from '@doltech/icons/IconArrowsArrowRight';
import { IconChevronChevronUp } from '@doltech/icons/IconChevronChevronUp';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { SkillEnum } from '@doltech/utils/lib/constants';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { ButtonContentGeneral } from '@doltech/ui/lib/figma/Button/ButtonContentGeneral/ButtonContentGeneral';
import { ButtonSize } from '@doltech/ui/lib/figma/Button/ButtonSize/ButtonSize';
import { ButtonStyles } from '@doltech/ui/lib/figma/Button/ButtonStyles/ButtonStyles';
import { useTestSubmissionStore } from '../../model/test-submissions.hook';

const IconExpandCollapseWrapper = styled.div`
  display: flex;
  transition: all 0.2s ease;
  &.active {
    transform: rotate(180deg);
  }
`;

const Main = styled.div`
  display: flex;
  align-items: center;
  .hidden {
    display: none;
  }

  button {
    &:not(:last-child) {
      margin-right: 16px;
    }
  }
`;

export interface ButtonQuestionNavigationProps {
  disableSubmitAction?: boolean;
  enableEvent?: boolean;
  onSubmitWithEvents?: () => void;
}

export const ButtonQuestionNavigation = observer((props: ButtonQuestionNavigationProps) => {
  const store = useTestSubmissionStore();
  switch (store.skill) {
    case SkillEnum.READING:
      return <ReadingButtonQuestionNavigation {...props} />;
    case SkillEnum.LISTENING:
      return <ListeningButtonQuestionNavigation {...props} />;
  }
  return null;
});

export const ReadingButtonQuestionNavigation = observer((props: ButtonQuestionNavigationProps) => {
  const store = useTestSubmissionStore();

  const { disableSubmitAction, enableEvent, onSubmitWithEvents } = props;

  return (
    <Main>
      <Button.Icon
        type="secondary"
        variant="outline"
        className="btn-expand-collapse-bottom-navigation-bar"
        onClick={store.toggleExpandCollapseBottomNavigationBar}
      >
        <IconExpandCollapseWrapper className={cl({ active: store.bottomNavigationExpanded })}>
          <IconChevronChevronUp />
        </IconExpandCollapseWrapper>
      </Button.Icon>
      <div className="btn-question-navigation">
        {!store.isLastSection && (
          <ButtonStyles
            color="dark"
            buttonStyle="outline"
            colorStyle="matte"
            onClick={() => {
              if (store.preventUserAction()) return;
              store.nextSection();
            }}
            content={
              <ButtonSize
                verticalPadding
                size="large"
                content={<ButtonContentGeneral text="Tiếp theo" />}
              />
            }
          />
        )}

        <Button.Primary
          onClick={() => {
            if (store.preventUserAction()) return;
            if (enableEvent) {
              onSubmitWithEvents();
              return;
            }
            store.openSubmitModal();
          }}
          iconRight={<IconArrowsArrowRight />}
          disabled={disableSubmitAction}
          className={cl('btn-submit-do-test', { hidden: !store.isLastSection })}
        >
          Submit
        </Button.Primary>
      </div>
    </Main>
  );
});

export const ListeningButtonQuestionNavigation = observer(
  (props: ButtonQuestionNavigationProps) => {
    const { onSubmitWithEvents } = props;
    const store = useTestSubmissionStore();
    const { isLastSection, currentSectionIndex, nextSection } = store;
    // const { isReviewing, currentSectionIndex, totalSections, id, prepareDataForSubmit } = store;

    // const renderNoneSubmitSectionMessage = () => {
    //   return (
    //     <Typography.Text variant="semi-bold/16-24" color="white100">
    //       Bạn phải nghe hết section {totalSections} bạn mới có thể nộp bài.
    //     </Typography.Text>
    //   );
    // };

    const renderSubmitButton = React.useCallback(() => {
      if (!isLastSection) {
        return (
          <Main>
            <Button.Primary
              onClick={() => nextSection(true)}
              iconRight={<IconArrowsArrowRight />}
              className="btn-submit-do-test"
            >
              Section {currentSectionIndex + 2}
            </Button.Primary>
          </Main>
        );
      }
      return (
        <Main>
          <Button.Primary
            onClick={onSubmitWithEvents}
            iconRight={<IconArrowsArrowRight />}
            className="btn-submit-do-test"
          >
            Submit
          </Button.Primary>
        </Main>
      );
    }, [nextSection, isLastSection, currentSectionIndex, onSubmitWithEvents]);

    // if (!isReviewing && currentSectionIndex <= totalSections - 1) {
    //   return (
    //     <Tooltip
    //       trigger="click"
    //       title={() => renderNoneSubmitSectionMessage()}
    //       placement="topRight"
    //     >
    //       {renderSubmitButton()}
    //     </Tooltip>
    //   );
    // }
    return renderSubmitButton();
  }
);
